import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CountrySelect } from "@/components/crm/CountrySelect";

export const NewLeadDialog = ({ open, onClose, onCreate, creating }) => {
  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  const close = () => { setName(""); setCountry(""); onClose(); };
  const submit = () => name.trim() && onCreate({ customerName: name.trim(), country });

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="new-lead-dialog" className="rounded-2xl sm:max-w-md">
        <DialogHeader><DialogTitle className="text-xl">New lead</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-500 -mt-2">Only the customer name is needed. Everything else can be added later.</p>
        <input
          data-testid="new-lead-customer-name"
          autoFocus
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && submit()}
          placeholder="Potential customer name"
          className="w-full h-12 px-4 rounded-xl border border-slate-300 text-base outline-none focus:border-slate-500 transition-colors"
        />
        <CountrySelect testId="new-lead-country" value={country} onChange={setCountry} className="h-12" />
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="ghost" onClick={close} className="h-11 rounded-xl">Cancel</Button>
          <Button data-testid="new-lead-save" disabled={!name.trim() || creating} onClick={submit} className="h-11 px-6 rounded-xl bg-slate-900 hover:bg-slate-800">
            {creating ? "Saving…" : "Create lead"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
